import { DatePipe } from '@angular/common';

const datePipeEn: DatePipe = new DatePipe('en-US')

export function convertUTCDateToLocalDate(date: Date, format?: string): Date {
  if (date) {
    let utcDate = datePipeEn.transform(date, 'YYYY-MM-dd HH:mm:ss').toString() + ' UTC';
    let localDate = new Date(datePipeEn.transform(new Date(utcDate), format ? format : 'YYYY-MM-dd HH:mm:ss').toString());
    return localDate;
  } else {
    return date;
  }
}

export function convertLocalDateToUTCDate(date: Date, format?: string): Date {
  if (date) {
    let localDate = datePipeEn.transform(date, 'YYYY-MM-dd HH:mm:ss').toString();
    let utcDate = new Date(datePipeEn.transform(new Date(localDate + ' UTC'), format ? format : 'YYYY-MM-dd HH:mm:ss').toString());
    return utcDate;
  } else {
    return date;
  }
}

export function isIsoDate(str: string): boolean {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
  const d = new Date(str);
  return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str; // valid date 
}
